import { Component, h } from 'preact';
import get from '../utils/get';

import Story from './story';

class RelatedStories extends Component {
  constructor () {
    super();

    this.state = {
      stories: []
    };
  }

  loadStories () {
    const tag = this.props.tag;
    const src = `https://www.texastribune.org/api/content/?content_type=story,audio,video,pointer&tag=${tag}&fields=id,url,readable_pub_date,seo_headline,short_summary,lead_art&limit=4&format=json`;

    get(src).then(JSON.parse).then(({ results }) => {
      this.setState({ stories: results });
    }).catch((err) => {
      console.error(err);
    });
  }

  componentDidMount () {
    this.loadStories();
  }

  render () {
    const stories = this.state.stories;
    const isColumn = this.props.isColumn;
    const title = this.props.title;

    const renderedStories = stories.map((story) => {
      return <Story {...story} />;
    });

    return (
      <div class={`related-stories${isColumn ? ' related-stories--column' : ''}`}>
        {title && <h3 class="section-sub-header">{title}</h3>}
        {renderedStories}
      </div>
    );
  }
}

export default RelatedStories;



// WEBPACK FOOTER //
// ./components/related-stories.js